import { extendTheme } from "@chakra-ui/react";
import "@fontsource/poppins";

export const CustomFont = extendTheme({
    fonts:{
        heading:"Poppins",
        body:"Poppins"
    }
})